import { useCallback, useRef, type ReactNode } from 'react';

import { useFormatNumber } from '~/i18n/hooks/useFormatNumber/useFormatNumber';
import {
  NumberFormatProvider,
  type NumberFormatter,
} from '~/packages/eds/src/context/NumberFormat/NumberFormat';

/**
 * Bridges EDS 2.0 numeric display to the app's formatting-locale-aware number
 * formatter. `packages/eds` stays locale-agnostic; this adapter injects
 * `useFormatNumber` so values respect the user's formatting locale
 * (`LOCALE_KEY`), not react-intl's language locale.
 */
export function EdsNumberFormatProvider({ children }: { children: ReactNode }) {
  const formatNumberWithOptions = useFormatNumber();
  const formatNumberWithOptionsRef = useRef(formatNumberWithOptions);
  formatNumberWithOptionsRef.current = formatNumberWithOptions;

  const formatNumber = useCallback<NumberFormatter>(
    (value) => formatNumberWithOptionsRef.current(value),
    [],
  );

  return (
    <NumberFormatProvider formatNumber={formatNumber}>
      {children}
    </NumberFormatProvider>
  );
}
